import React, { useEffect, useState, useContext } from "react";
import AxiosWithOutAuthInstance from "../../config/api/withoutauth.axios";
import LanguageContext from "../../context/LanguageProvider";
import { token } from "../../Helper/apiToken";
import { Container, Row, Col } from "react-bootstrap";
import DefaultLayout from "../../components/layout/defaultlayout/DefaultLayout";

const PrivacyPolicy = () => {
  const [privacyPolicy, setPrivacyPolicy] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { language } = useContext(LanguageContext);

  useEffect(() => {
    const fetchPrivacyPolicy = async () => {
      setLoading(true);
      setError(null);
      try {
        AxiosWithOutAuthInstance.get(
          `web-privacy-policy?api_key=${token}`
        ).subscribe((response) => {
          setPrivacyPolicy(response?.data?.data); // or res?.data?.data depending on your response
        });
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchPrivacyPolicy();
  }, []);

  if (loading) return <div>Loading Privacy Policy...</div>;
  if (error)
    return (
      <div>Error: {error.message || "Failed to fetch Privacy Policy"}</div>
    );

  return (
    <DefaultLayout>
      <Container className="privacy-container">
        <Row>
          <Col>
            {privacyPolicy ? (
              <div>
                {" "}
                {language === "en" ? (
                  <>
                    {" "}
                    <div
                      className="editor__html"
                      dangerouslySetInnerHTML={{
                        __html: privacyPolicy?.policy_en,
                      }}
                    />{" "}
                  </>
                ) : (
                  <>
                    {" "}
                    <div
                      className="editor__html"
                      dangerouslySetInnerHTML={{
                        __html: privacyPolicy?.policy_bn,
                      }}
                    />{" "}
                  </>
                )}{" "}
              </div>
            ) : (
              <p className="text-center">Privacy Policy not found.</p>
            )}
          </Col>
        </Row>
      </Container>
    </DefaultLayout>
  );
};

export default PrivacyPolicy;
